// extracted by mini-css-extract-plugin
export default {"footerLink":"c-f_cb"};